export default {
  title: 'Êtes-vous sûr de vouloir quitter?',
  message: 'En quittant, vous perdrez vos informations.',
  cancelButton: 'Annuler',
  confirmButton: 'Quitter',
};
